import React from "react";
import "./ReactNativeHero.css";
import { NavLink } from "react-router-dom";

const ReactNativeHero = () => {
    return (
        <>
            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    background:
                        "linear-gradient(180deg,#ffffff 0%,#f7faff 45%,#ffffff 100%)",
                    padding: "130px 24px 110px",
                }}
            >
                {/* Animated Background */}
                <div className="rn-glow rn-glow1"></div>
                <div className="rn-glow rn-glow2"></div>

                <div
                    style={{
                        maxWidth: "1320px",
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: "1.1fr .9fr",
                        gap: "70px",
                        alignItems: "center",
                        position: "relative",
                        zIndex: 2,
                    }}
                    className="rn-grid"
                >
                    {/* LEFT CONTENT */}
                    <div
                        style={{
                            animation: "rnFadeUp .9s ease both",
                        }}
                    >
                        <div className="rn-badge">
                            ⚛ REACT NATIVE APP DEVELOPMENT
                        </div>

                        <h1
                            style={{
                                fontSize: "clamp(46px,6vw,82px)",
                                lineHeight: 0.95,
                                fontWeight: 800,
                                margin: "24px 0",
                                color: "#111",
                                fontFamily: "'Syne',sans-serif",
                                letterSpacing: "-3px",
                            }}
                        >
                            Build Fast
                            <br />
                            <span className="rn-gradient-text">
                                React Native
                            </span>
                            <br />
                            Apps
                        </h1>

                        <p
                            style={{
                                color: "#666",
                                fontSize: "18px",
                                lineHeight: 1.9,
                                maxWidth: "650px",
                                fontFamily:
                                    "'Plus Jakarta Sans',sans-serif",
                                marginBottom: "40px",
                            }}
                        >
                            We create scalable React Native applications
                            with stunning UI, lightning-fast performance,
                            reusable components and seamless experiences
                            across Android & iOS platforms.
                        </p>

                        {/* BUTTONS */}


                        <div className="rn-btn-wrap">
                            <NavLink to="/Contactus">
                                <a href="#" className="rn-btn-primary">
                                    Start Project →
                                </a>
                            </NavLink>

                        </div>


                        {/* STATS */}
                        <div className="rn-stats">
                            {[
                                {
                                    number: "120+",
                                    text: "Apps Delivered",
                                },
                                {
                                    number: "99%",
                                    text: "Client Satisfaction",
                                },
                                {
                                    number: "4.9★",
                                    text: "Average Ratings",
                                },
                            ].map((item, i) => (
                                <div
                                    key={i}
                                    className="rn-stat-box"
                                >
                                    <h3>{item.number}</h3>
                                    <p>{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* RIGHT VISUAL */}
                    <div
                        style={{
                            position: "relative",
                            height: "700px",
                        }}
                        className="rn-visual"
                    >
                        {/* MAIN CARD */}
                        <div className="rn-main-phone">
                            <div className="rn-phone-inner">

                                {/* top */}
                                <div className="rn-phone-top">
                                    <div className="rn-react-logo">
                                        ⚛
                                    </div>

                                    <h3>
                                        React Native
                                        <br />
                                        Experience
                                    </h3>

                                    <p>
                                        Fast, modern & scalable mobile apps.
                                    </p>
                                </div>

                                {/* UI Cards */}
                                <div className="rn-ui-cards">

                                    {[1, 2, 3].map((item, i) => (
                                        <div
                                            key={i}
                                            className="rn-ui-card"
                                        >
                                            <div className="rn-ui-left">
                                                <div className="rn-ui-circle"></div>

                                                <div>
                                                    <div className="rn-ui-line"></div>
                                                    <div className="rn-ui-line small"></div>
                                                </div>
                                            </div>

                                            <div className="rn-ui-badge">
                                                {70 + i * 10}%
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* FLOATING CARD */}
                        <div className="rn-floating-card rn-card1">
                            <span>⚡</span>
                            <div>
                                <h4>Fast Performance</h4>
                                <p>Optimized mobile experience</p>
                            </div>
                        </div>

                        <div className="rn-floating-card rn-card2">
                            <span>📱</span>
                            <div>
                                <h4>Cross Platform</h4>
                                <p>iOS & Android support</p>
                            </div>
                        </div>

                        {/* ORBIT */}
                        <div className="rn-orbit"></div>
                    </div>
                </div>
                {/* <style>{`.rn-btn-wrap a {
    text-decoration: none;
}`}</style> */}
            </section >
        </>
    );
};

export default ReactNativeHero;